<template>
  <div>
    <div v-if="work">
      <div v-for="decision in work.decisions" :key="decision.id">
        <div v-for="media in decision.media" :key="media.id">
          <a target="_blank" :href="media.links.original">Скачать {{ media.file_name }}</a>
        </div>
      </div>
    </div>
  </div>

</template>
<script>

export default {
  name: "text",
  props: {
    work: {
      default: null,
    },
  },
  data() {
    return {

    };
  },
};
</script>

